import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import {
  UnfoldLess,
  UnfoldMore,
  Curtains,
  CurtainsClosed,
  VerticalShades,
} from "@mui/icons-material";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";

const WindowOpenCloseDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const getComponentBgColor = useComponentBackgroundColor();
  const [status, setStatus] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setStatus(
        currentValue === "" || currentValue === null ? "unknown" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!status) return "unknown";
    return status;
  };

  const isOpen = () => {
    return (
      status === "open" || status === "opening" || status === "partially open"
    );
  };

  const getStatusIcon = () => {
    switch (status) {
      case "open":
      case "opening":
        return <VerticalShades style={{ fontSize: "1.5rem" }} />;
      case "partially open":
        return <Curtains style={{ fontSize: "1.5rem" }} />;
      case "closed":
      case "closing":
        return <CurtainsClosed style={{ fontSize: "1.5rem" }} />;
      default:
        return <Curtains style={{ fontSize: "1.5rem" }} />;
    }
  };

  const handleCommand = (command) => {
    if (pattern && pattern.endsWith("_R")) return;
    if (!widgetData?.items?.$w2) return;

    const updatedWidget = {
      ...widgetData.items.$w2,
      value: command,
    };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const hasControl = !!widgetData?.items?.$w2;

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Window Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "60px",
          backgroundColor: "hsl(var(--card))",
          border: isOpen() ? `2px solid hsl(var(--primary))` : "none",
        }}
      >
        <Typography className="font-bold capitalize">
          Window status: {getStatusText()}
        </Typography>
        <div className="h-10 aspect-square flex items-center justify-center flex-shrink-0">
          {getStatusIcon()}
        </div>
      </div>

      {/* Window Controls */}
      {hasControl && (
        <div
          className="flex flex-col gap-3 p-4 rounded-2xl"
          style={{
            backgroundColor: getComponentBgColor("hsl(var(--card))"),
          }}
        >
          <Typography className="font-bold">Window Controls</Typography>

          <div className="flex justify-center gap-4">
            <button
              onClick={() =>
                !disabled && status !== "closing" && handleCommand("close")
              }
              disabled={disabled || status === "closing"}
              className="flex flex-col items-center justify-center flex-1 px-4 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 shadow-none"
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                backgroundColor: "hsl(var(--primary))",
                color: "hsl(var(--primary-foreground))",
                border: "none",
                cursor:
                  disabled || status === "closing" ? "not-allowed" : "pointer",
                opacity: disabled || status === "closing" ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!disabled && status !== "closing") {
                  e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
              }}
            >
              <div className="mb-2">
                <UnfoldLess
                  style={{
                    transform: "rotate(90deg)",
                    fontSize: "1.5rem",
                  }}
                />
              </div>
              <Typography className="text-xs">Close</Typography>
            </button>

            <button
              onClick={() =>
                !disabled && status !== "opening" && handleCommand("open")
              }
              disabled={disabled || status === "opening"}
              className="flex flex-col items-center justify-center flex-1 px-4 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 shadow-none"
              style={{
                paddingTop: "12px",
                paddingBottom: "12px",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                backgroundColor: "hsl(var(--primary))",
                color: "hsl(var(--primary-foreground))",
                border: "none",
                cursor:
                  disabled || status === "opening" ? "not-allowed" : "pointer",
                opacity: disabled || status === "opening" ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!disabled && status !== "opening") {
                  e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
              }}
            >
              <div className="mb-2">
                <UnfoldMore
                  style={{
                    transform: "rotate(90deg)",
                    fontSize: "1.5rem",
                  }}
                />
              </div>
              <Typography className="text-xs">Open</Typography>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WindowOpenCloseDetail1Widget;
